<template>
    <v-layout class="plan-calendar mt-4">
        <v-layout wrap justify-center class="plan-calendar__content">
            <div
                v-for="monthIndex in 12"
                :key="getMonth(monthIndex).format('YYYY.MM.DD')"
                class="plan-calendar__month"
            >
                <h3 class="plan-calendar__month-title mb-2">
                    {{ $t(getMonth(monthIndex).format('MMMM')) }}
                </h3>
                <v-layout justify-space-between class="plan-calendar__weekdays">
                    <div
                        v-for="weekday in 7"
                        :key="weekdays[weekday - 1]"
                        class="plan-calendar__weekday"
                    >
                        {{ $t(weekdays[weekday - 1]) }}
                    </div>
                </v-layout>
                <v-layout wrap>
                    <div
                        v-for="emptyDay in getMonth(monthIndex).set('date', 0).day()"
                        :key="emptyDay"
                        class="plan-calendar__day"
                    ></div>
                    <study-plan-calendar-day
                        v-for="day in getMonth(monthIndex).daysInMonth()"
                        :key="day + 10"
                        :day="day"
                        :hover-event-id="hoverEventId"
                        :month-index="monthIndex - 1"
                        :event-type-list="menuList"
                        :menu-list="get_employee_menu_list"
                        :events="accesses ? get_events : {}"
                        :selected-range="selectedRange"
                        :is-start-range-select="isStartRangeSelect"
                        @menu-item-click="menuItemClickHandle"
                        @start-range-select="startRangeSelectHandle"
                        @update-selected-range="updateSelectedRangeHandle"
                        @event-day-hover="eventHoverHandle"
                        @event-day-leave="eventLeaveHandle"
                        @close-menu="clearSelectedRangeHandle"
                    />
                </v-layout>
            </div>
        </v-layout>
        <study-plan-delete-modal
            :open="!!eventDeletionID"
            @close="closeDeletionModalHandle"
            @confirm="confirmDeletionHandle"
        />
        <study-plan-event-form
            v-if="accesses && !isUpdatingEvent"
            :event-data="creationEvent"
            :open="openEventForm"
            :event-type-list="get_event_type_list"
            @submit="createEventHandle"
            @close="closeCreateEventFormHandle"
        />
        <study-plan-event-form
            v-if="accesses && isUpdatingEvent"
            :event-data="updateEvent"
            :is-update="true"
            :open="openEventForm"
            :event-type-list="get_event_type_list"
            @submit="updateEventHandle"
            @close="closeUpdateEventFormHandle"
        />
        <study-plan-request-form
            v-if="!accesses"
            :open="openRequestForm"
            :request="creationRequest"
            @close="closeCreateRequestFormHandle"
            @submit="createRequestHandle"
        />
    </v-layout>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import dayjs from 'dayjs';
import StudyPlanCalendarDay from './Study_plan_calendar_day.vue';
import StudyPlanEventForm from './Study_plan_event_form.vue';
import StudyPlanRequestForm from './Study_plan_request_form.vue';
import StudyPlanDeleteModal from '@/components/view_blocks/Study_plan/Study_plan_delete_modal.vue';

export default {
  name      : 'StudyPlanCalendar',
  components: {
    StudyPlanEventForm,
    StudyPlanRequestForm,
    StudyPlanCalendarDay,
    StudyPlanDeleteModal,
  },
  data: () => ({
    dayjs,
    selectedRange     : [],
    hoverEventId      : null,
    isStartRangeSelect: false,
    openEventForm     : false,
    openRequestForm   : false,
    isUpdatingEvent   : false,
    weekdays          : ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'],
    updateEvent       : null,
    eventDeletionID   : null,
    creationEvent     : {
      dateStart: '',
      dateEnd  : '',
      time     : '08:00',
      comment  : '',
      eventType: '',
    },
    creationRequest: {
      dateStart: '',
      phone    : '',
      time     : '08:00',
      comment  : '',
      employees: '1',
      company  : '',
      courses  : [],
    },
  }),
  computed: {
    ...mapGetters('profile/user', [
      'user',
    ]),
    ...mapGetters('study_plan', [
      'get_events',
      'get_employee_menu_list',
      'get_student_menu_list',
      'get_event_type_list',
    ]),
    accesses() {
      if (this.user.role) {
        return !!this.user.role.managment_study_events.rights.length;
      }
      return false;
    },
    menuList() {
      return this.accesses ? this.get_event_type_list : this.get_student_menu_list;
    },
    nearestForwardEvent() {
      const formattedDateStart = dayjs(this.selectedRange[0]);
      const eventDates = Object.keys(this.get_events).sort();
      const formattedLastEventDate = dayjs(eventDates[eventDates.length - 1]);
      let nearestEvent = null;
      let countDays = 0;
      while (
        !nearestEvent &&
        formattedLastEventDate &&
        formattedDateStart.isBefore(formattedLastEventDate)
      ) {
        const date = formattedDateStart.add(countDays, 'day');
        if (this.get_events[date.format('YYYY.MM.DD')]) {
          nearestEvent = date;
        }
        countDays += 1;
      }
      return nearestEvent;
    },
    nearestBackEvent() {
      const formattedDateEnd = dayjs(this.selectedRange[this.selectedRange.length - 1]);
      const eventDates = Object.keys(this.get_events).sort();
      const formattedFirstEventDate = dayjs(eventDates[0]);
      let nearestEvent = null;
      let countDays = 0;
      while (
        !nearestEvent &&
        formattedFirstEventDate &&
        formattedDateEnd.isAfter(formattedFirstEventDate)
      ) {
        const date = formattedDateEnd.add(-countDays, 'day');
        if (this.get_events[date.format('YYYY.MM.DD')]) {
          nearestEvent = date;
        }
        countDays += 1;
      }
      return nearestEvent;
    },
  },
  mounted() {
    document.addEventListener('mouseup', this.mouseupHandle);
    if (this.accesses) {
      this.$store.dispatch('study_plan/fetch_event_types');
    }
    this.$store.dispatch('study_plan/fetch_events');
  },
  beforeDestroy() {
    this.SET_EVENTS({});
    this.SET_DISABLED_DATES([]);
    document.removeEventListener('mouseup', this.mouseupHandle);
  },
  methods: {
    ...mapMutations('study_plan', ['SET_EVENTS', 'SET_DISABLED_DATES']),
    getMonth(monthIndex) {
      return dayjs().set('month', monthIndex - 1);
    },
    menuItemClickHandle(eventType, date) {
      if (eventType === 'delete') {
        return this.openDeletionModalHandle(date);
      }
      if (eventType === 'edit') {
        return this.openUpdateEventFormHandle(date);
      }
      if (this.accesses) {
        return this.openCreateEventFormHandle(eventType);
      }
      return this.openCreateRequestFormHandle(eventType);
    },
    eventHoverHandle(eventId) {
      this.hoverEventId = eventId;
    },
    eventLeaveHandle() {
      this.hoverEventId = null;
    },
    openDeletionModalHandle(date) {
      this.eventDeletionID = this.get_events[date.format('YYYY.MM.DD')].id;
    },
    closeDeletionModalHandle() {
      this.eventDeletionID = null;
      this.selectedRange = [];
    },
    confirmDeletionHandle() {
      this.$store.dispatch('study_plan/delete_event', this.eventDeletionID);
      this.closeDeletionModalHandle();
    },
    openUpdateEventFormHandle(date) {
      const currentEvent = this.get_events[date.format('YYYY.MM.DD')];
      this.updateEvent = {
        comment  : currentEvent.comment,
        dateStart: currentEvent.start,
        dateEnd  : currentEvent.end,
        eventType: currentEvent.type,
        time     : currentEvent.startTime,
        id       : currentEvent.id,
      };
      this.isUpdatingEvent = true;
      this.openEventForm = true;
    },
    closeUpdateEventFormHandle() {
      this.updateEvent = null;
      this.isUpdatingEvent = false;
      this.openEventForm = false;
      this.selectedRange = [];
    },
    updateEventHandle(form) {
      this.$store.dispatch('study_plan/update_event', form);
    },
    openCreateEventFormHandle(eventType) {
      const startDate = dayjs(this.selectedRange[0]).format('DD.MM.YYYY');
      const endDate = dayjs(this.selectedRange[this.selectedRange.length - 1]).format('DD.MM.YYYY');
      this.creationEvent = {
        ...this.creationEvent,
        eventType: eventType,
        dateStart: startDate < endDate ? startDate : endDate,
        dateEnd  : startDate > endDate ? startDate : endDate,
      };
      this.openEventForm = true;
    },
    closeCreateEventFormHandle() {
      this.creationEvent = {
        ...this.creationEvent,
        eventType: '',
        dateStart: '',
        dateEnd  : '',
      };
      this.openEventForm = false;
      this.selectedRange = [];
    },
    createEventHandle(form) {
      this.$store.dispatch('study_plan/create_event', form);
    },
    openCreateRequestFormHandle() {
      const startDate = dayjs(this.selectedRange[0]).format('DD.MM.YYYY');
      this.creationRequest = {
        ...this.creationRequest,
        company  : this.user.company_name,
        dateStart: startDate,
      };
      this.openRequestForm = true;
    },
    closeCreateRequestFormHandle() {
      this.creationRequest = {
        dateStart: '',
        comment  : '',
        time     : '08:00',
        employees: '1',
        company  : '',
        courses  : [],
      };
      this.openRequestForm = false;
      this.selectedRange = [];
    },
    createRequestHandle(form) {
      this.$store.dispatch('study_plan/create_request', form);
    },
    startRangeSelectHandle(flag) {
      this.isStartRangeSelect = flag;
    },
    mouseupHandle() {
      this.isStartRangeSelect = false;
    },
    clearSelectedRangeHandle() {
      this.selectedRange = [];
    },
    updateSelectedRangeHandle(date) {
      if (!this.isStartRangeSelect) return;
      if (!this.selectedRange.length) {
        this.selectedRange.push(date);
        return;
      }
      if (!this.accesses) return; // Выключаем range select для пользователей, оформляющих заявки

      const firstRangeDate = this.selectedRange[0];

      if (dayjs(date).isBefore(dayjs(firstRangeDate))) {
        const selectedRange = [];
        const finalDate = !this.nearestBackEvent || dayjs(date).isAfter(this.nearestBackEvent)
          ? dayjs(date)
          : this.nearestBackEvent;
        for (let i = 0; i <= dayjs(firstRangeDate).diff(finalDate, 'day'); i += 1) {
          const dateToPush = dayjs(firstRangeDate).add(-i, 'day').format('YYYY.MM.DD');
          if (!dayjs(firstRangeDate).add(-i, 'day').isSame(this.nearestBackEvent)) {
            selectedRange.push(dateToPush);
          }
        }
        this.selectedRange = selectedRange;
        return;
      }
      if (dayjs(date).isAfter(dayjs(firstRangeDate))) {
        const selectedRange = [];
        const finalDate = !this.nearestForwardEvent || dayjs(date).isBefore(this.nearestForwardEvent)
          ? dayjs(date)
          : this.nearestForwardEvent;
        for (let i = 0; i <= finalDate.diff(dayjs(firstRangeDate), 'day'); i += 1) {
          const dateToPush = dayjs(firstRangeDate).add(i, 'day').format('YYYY.MM.DD');
          if (!dayjs(firstRangeDate).add(i, 'day').isSame(this.nearestForwardEvent)) {
            selectedRange.push(dateToPush);
          }
        }
        this.selectedRange = selectedRange;
        return;
      }
    },
  },
};
</script>

<style lang="less">
@import url('../../../less/variables');

.plan-calendar {
    &__content {
        font-family: @light-font;
        font-weight: 300;
        max-width: 1200px;
        gap: 80px;
    }
    &__month {
        max-width: 240px;
        width: 100%;
        &-title {
            font-size: 18px;
            line-height: 25px;
            text-align: center;
            color: #231F20;
            font-weight: 400;
        }
    }
    &__weekday, &__day, &__day-btn {
        font-family: @light-font;
        width: 34px;
        height: 34px;
        font-weight: 400;
        text-align: center;
        border-radius: 50%;
        transition: background-color .2s ease-in-out, color .2s ease-in-out;
    }
    &__day {
        color: #DEDEDE;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &__day-btn {
        color: @accent-color-dark;
        &_current {
            color: @main-color;
        }
        &_yellow {
            background-color: #FFFFAE;
        }
        &_blue {
            background-color: #B5C6E7;
        }
        &_orange {
            background-color: #FFD6B0;
        }
        &_grey {
            background-color: #DBDBDB;
        }
        &_left-round {
            border-bottom-right-radius: 0;
            border-top-right-radius: 0;
        }
        &_right-round {
            border-bottom-left-radius: 0;
            border-top-left-radius: 0;
        }
        &:not(:disabled):hover,
        &_selected {
            background-color: @main-color;
            color: #fff;
        }
    }
    &__menu-item:hover, &__menu-item:hover &__menu-icon {
        color: @main-color;
    }
    &__menu-item a {
        height: 36px;
        font-size: 16px;
        font-weight: 300;
        padding: 0 12px;
    }
    &__menu-icon {
        margin-right: 8px;
    }
    &__comment {
      font-size: 15px;
    }
}
.study-form {
    &_text-grey {
        color: #838688;
    }
    &_text-dark-grey {
        color: #4A4A4A;
    }
    &__padding {
        padding: 0 60px;
    }
    &__title {
        font-size: 48px;
        line-height: 58px;
        font-family: @main-font;
        color: #4A4A4A;
        font-weight: 400;
    }
    &__label {
        font-size: 15px;
        line-height: 21px;
        display: inline-block;
        color: #838688;
        margin-bottom: 12px;
    }
    &__error-field {
        color: #e2173d;
        font-size: 12px;
        line-height: 14px;
        min-height: 16px;
        margin-top: 4px;
    }
    &__input input,
    &__input textarea {
        border: 1px solid #DEDEDE;
        height: 46px;
        min-height: 46px;
        font-size: 20px;
        line-height: 28px;
        font-family: @light-font;
        padding: 10px 16px 8px;
    }
    &__event-date .v-picker__title {
      background-color: #e2173d;
    }
    &__select.v-select.v-text-field--enclosed .v-select__selections {
        padding-top: 0;
    }
    &__select.v-select.v-text-field--enclosed .v-select__selection {
        padding: 10px 16px 8px;
        font-size: 20px;
        line-height: 28px;
        font-family: @light-font;
    }
    &__select.v-text-field.v-text-field--enclosed .v-input__append-inner {
        margin-top: 12px;
        margin-right: 20px;
    }
    &__actions {
        padding-top: 40px;
        padding-bottom: 60px;
        gap: 40px;
    }
    &__btn {
        height: unset;
        min-width: unset;
        padding: 16px 32px;
        font-size: 16px;
        line-height: 19px;
    }
}
.v-date-picker-table .v-btn.v-btn--active {
  color: rgba(0,0,0,.87);
}
.v-time-picker-clock__item.v-time-picker-clock__item--active.accent,
.v-time-picker-clock__hand.accent{
  background-color: #e2173d;
}
</style>
